// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"123":"30fc4ec5","3326":"ccd8e39d","6167":"76590997","7500":"76590997","7998":"ec451242","8115":"221fc81b"}[chunkId] + ".chunk.css";
};